import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=fafc40fe"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=fafc40fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports